// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__37cIl","buttons":"RemoveExpirationActionButtons_buttons__uF4Wx"};